<template>
  <div id="events-wrapper">
    <app-header></app-header>

    <div class="container">
      <div class="row">
        <div class="event-cell col-lg-4 col-md-6 col-sm-12"
             v-for="key in eventKeys"
             v-bind:key="key">
          <router-link tag="a" :to="'/event/' + key">
            <img class="event-image"
                 v-bind:src="events[key].img"
                 v-bind:alt="events[key].name"/>
            <div class="event-name">{{ events[key].name }}<br/>"{{ events[key].theme }}"</div>
            <div class="event-date">{{ (new Date(events[key].date)).toDateString() }}</div>
          </router-link>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import EventsData from '@/assets/events.json';


export default {
  name: 'Events',
  components: {
    'app-header': Header,
    'app-footer': Footer,
  },
  data() {
    return {
      events: EventsData,
      eventKeys: ['swing_by', 'shizuku', 'rock_your_mind'],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/global";

#events-wrapper {
  margin-top: 96px;
  padding: 0;
}

.event-cell {
  @include media-breakpoint-down(sm) {
    margin-bottom: 24px;
  }

  .event-image {
    width: 100%;
    object-fit: cover;

    @include media-breakpoint-down(xl) {
      height: 233px;
    }

    @include media-breakpoint-down(lg) {
      height: 193px;
    }

    @include media-breakpoint-down(md) {
      height: 153px;
    }

    @include media-breakpoint-down(sm) {
      height: auto;
      max-height: 320px;
      min-height: 160px;
    }
  }

  .event-name {
    font-size: 28px;
    line-height: 140%;
    font-weight: bolder;
    margin: 12px 0 4px 4px;
    color: $brand-darker;
  }

  .event-date {
    font-size: 16px;
    color: $brand-primary;
    font-weight: bolder;
    margin: 0 0 8px 6px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Events.vue